// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  -webkit-user-select: none;
          user-select: none;
}

.timeline-track {
  background-color: #475569 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}

.segment-marker {
  transition: opacity 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);
  min-width: 4px;
}

.segment-marker:hover {
  opacity: 0.95;
  filter: brightness(1.1);
}

.current-position-indicator {
  pointer-events: none;
}

.position-label {
  pointer-events: none;
  font-size: 10px;
}

.segment-label {
  pointer-events: none;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0,0,0,0.8);
  color: #f8fafc !important;
}

.max-height-300 {
  max-height: 300px;
}

.max-height-200 {
  max-height: 200px;
}

.video-container {
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/VideoEdit.css"],"names":[],"mappings":"AAAA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD","sourcesContent":[".timeline-container {\n  user-select: none;\n}\n\n.timeline-track {\n  background-color: #475569 !important;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.segment-marker {\n  transition: opacity 0.2s ease;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);\n  min-width: 4px;\n}\n\n.segment-marker:hover {\n  opacity: 0.95;\n  filter: brightness(1.1);\n}\n\n.current-position-indicator {\n  pointer-events: none;\n}\n\n.position-label {\n  pointer-events: none;\n  font-size: 10px;\n}\n\n.segment-label {\n  pointer-events: none;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.8);\n  color: #f8fafc !important;\n}\n\n.max-height-300 {\n  max-height: 300px;\n}\n\n.max-height-200 {\n  max-height: 200px;\n}\n\n.video-container {\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
